import {
    CreateButton,
    DataTable,
    DateField,
    EditButton,
    ExportButton,
    List,
    ReferenceField,
    TextField,
} from '@/components/admin';
import { Card } from '@/components/ui/card';
import { Calendar } from 'lucide-react';
import { StatusBadgeField } from '../documents/shared/StatusBadge';
import { TopToolbar } from '../layout/TopToolbar';

const RFQListActions = () => (
    <TopToolbar>
        <CreateButton />
        <ExportButton />
    </TopToolbar>
);

export const RFQList = () => {
    return (
        <List 
            actions={<RFQListActions />}
            sort={{ field: 'created_at', order: 'DESC' }}
            className="p-6"
        >
            <Card className="border-none shadow-sm overflow-hidden">
                <DataTable rowClick="show">
                    <DataTable.Col 
                        source="reference" 
                        label="RFQ No." 
                        className="font-mono font-bold text-slate-900"
                    />
                    <DataTable.Col label="Project">
                        <ReferenceField source="project_id" reference="projects" link={false}>
                             <TextField source="name" className="text-blue-600 font-medium" />
                        </ReferenceField>
                    </DataTable.Col>
                    <DataTable.Col label="BoM">
                        <ReferenceField source="bom_id" reference="boms" link={false}>
                            <TextField source="reference" />
                        </ReferenceField>
                    </DataTable.Col>
                    <DataTable.Col label="Status">
                        <StatusBadgeField source="status" />
                    </DataTable.Col>
                    <DataTable.Col label="Due Date">
                        <div className="flex items-center gap-2 text-slate-500 text-xs font-semibold">
                            <Calendar className="w-3 h-3" />
                            <DateField source="due_date" />
                        </div>
                    </DataTable.Col>
                    <DataTable.Col>
                        <EditButton />
                    </DataTable.Col>
                </DataTable>
            </Card>
        </List>
    );
};
